// extracted by mini-css-extract-plugin
export default {"content":"CheckboxLabel_content__yMgoP","label":"CheckboxLabel_label__h9yDA"};